(function () {
    'use strict';

    var app = angular.module('app', [
        // Angular modules 
        'ngAnimate',        // animations
        'ngRoute',          // routing
        'ngSanitize',       // sanitizes html bindings (ex: sidebar.js)
        'ngMessages',       // Validation Messages
		'ngFileUpload',			// Upload di Files
		'angularFileUpload', // Upload di Files https://github.com/nervgh/angular-file-upload/wiki/Module-API
		'angularMoment',        // work with date
		'angular.filter',				//angular-filter https://github.com/a8m/angular-filter
		//'angular-img-cropper',	//Image Cropper (angular-img-cropper.js)
		//'ngImgCrop',					//Image Cropper
		//'imageCropper',				//Image Cropper (angular-image-cropper.js)
        'textAngular',              //TextAngular
        //'signature',                //Signature
        //'ngSignaturePad',
        // Custom modules 
        'common',           // common functions, logger, spinner
        'common.bootstrap', // bootstrap dialog wrapper functions
        // 3rd Party Modules
        'ui.bootstrap',      // ui-bootstrap (ex: carousel, pagination, dialog)
		'ui.sortable',			//sort item
		//'dialogs',					//finestre di Dialogo (dialogs.min.js)
        'infinite-scroll'    // infinite scroll
         //'googlechart'      //gauge di tipo 'tachimetro'

    ]);

    app.constant('_', _);     // Lodash library

    // Handle routing errors and success events
    app.run(['$route', '$location', '$rootScope', '$sce', 'datacontext', 'amMoment', function ($route, $location, $rootScope, $sce, datacontext, amMoment) {
        // Include $route to kick start the router.    

        $rootScope.filterKeydown = function (event, vm) {
            if (event.keyCode == 13) vm.cerca();
        };

        $rootScope.disableEnter = function (event, vm) {
            if (event.keyCode == 13) {
                event.preventDefault();
                return false;
            }
        };
        
        //ToDo: non funziona su mozilla Firefox
        $rootScope.disableLetter = function (event) {
            /*if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode == 8) || (event.keyCode == 9) || (event.keyCode == 46) || (event.keyCode == 37) || (event.keyCode == 39) || (event.keyCode >= 96 && event.keyCode <= 105)) {
                //Escludo tutti i numeri, freccia destra, freccia sinistra, backspace, delete, tab
            }
            else { //disabilito la digitazione del resto dei tasti della tastiera
                event.preventDefault();
                return false;
            }*/
        };

        $rootScope.trustAsHtml = function (string) {
            return $sce.trustAsHtml(string);
        };

        $rootScope.disableCtrlV = function (event) {
            /*
            var ctrlDown = false;
            if (event.keyCode === 17) {
                ctrlDown = true;
            }
                
            if (ctrlDown && event.keyCode == 86) {
                event.preventDefault();
                return false;
            }
            */
        };

        $rootScope.businessDays = function (param) {
            var start = moment(param);
            var end = start.clone().endOf('month');
            var start_offset = start.day() - 7;
            var end_offset = end.day();

            var end_sunday = end.clone().subtract('d', end_offset);
            var start_sunday = start.clone().subtract('d', start_offset);
            var weeks = end_sunday.diff(start_sunday, 'days') / 7;

            start_offset = Math.abs(start_offset);
            if (start_offset == 7)
                start_offset = 5;
            else if (start_offset == 1)
                start_offset = 0;
            else
                start_offset -= 2;


            if (end_offset == 6)
                end_offset--;

            return weeks * 5 + start_offset + end_offset;
        };

        $rootScope.businessAdd = function (days) {
            var d = this.clone().add('d', Math.floor(days / 5) * 7);
            var remaining = days % 5;
            while (remaining) {
                d.add('d', 1);
                if (d.day() !== 0 && d.day() !== 6)
                    remaining--;
            }
            return d;
        };

        $rootScope.isIE = function () {
            var ua = window.navigator.userAgent;
            var trident = ua.indexOf("Trident");
            var msie = ua.indexOf("MSIE ");
            if (msie > 0 || trident > 0)
                return true;
            else
                return false;
        };

        $rootScope.detectIE = function () {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // IE 12 => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        };

        $rootScope.detectIOS = function () {
            var isMacLike = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;

            return isMacLike;
        };

        $rootScope.exportAll = function (sTableName, sType, sEscape, sFontSize) {
            var ua = window.navigator.userAgent;
            var trident = ua.indexOf("Trident");
            var msie = ua.indexOf("MSIE ");

            if (msie > 0 || trident > 0) {
                var table = $(sTableName);
                var strCopy = $('<div></div>').html(table.clone()).html(); window.clipboardData.setData("Text", strCopy);

                var objExcel = new ActiveXObject("Excel.Application");
                objExcel.visible = false;
                var objWorkbook = objExcel.Workbooks.Add;
                var objWorksheet = objWorkbook.Worksheets(1);
                objWorksheet.Paste;
                objExcel.visible = true;

            }
            else {
                if (sType == 'pdf')
                    $(sTableName).tableExport({ type: sType, pdfFontSize: sFontSize, escape: sEscape });
                else
                    $(sTableName).tableExport({ type: sType, escape: sEscape });
            }
            amMoment.changeLocale('it');
        };
    }]);


    app.service('sectionMenu', function () {
        var _section = '';
        var _ableToWork = false;
        var _ableToAz1 = false;
        var _ableToAz2 = false;
        var _ableToAz3 = false;
        var _ableToAz4 = false;
        var _notificationCount = 0;
        var _notifications = [];
        var _lnkPDFBando = '';
        var _lnkPDFManuale = '';
        var _lnkOfficialSite = '';
        var _urlLogoHeader = '';
        var _showInfoMsg = false;
        var _projectUId = '';
        var _tipoCandidatura = 0;
        var _labelCF = '';

        var setSection = function (area) {
            return _section = area;
        };

        var getSection = function () {
            return _section;
        };

        var isSectionActive = function (area) {
            return _section == area;
        };

        var getClassIfActive = function (area) {
            return _section == area ? 'activated' : '';
        };

        var isAbleToWork = function () {
            return _ableToWork;
        };        

        var setAbleToWork = function (value) {
            return _ableToWork = value;
        };

        //Abilita il menu in base alle azioni attivate
        var isAbleToAz1 = function () {
            return _ableToAz1;
        };

        var setAbleToAz1 = function (value) {
            return _ableToAz1 = value;
        };

        var isAbleToAz2 = function () {
            return _ableToAz2;
        };

        var setAbleToAz2 = function (value) {
            return _ableToAz2 = value;
        };

        var isAbleToAz3 = function () {
            return _ableToAz3;
        };

        var setAbleToAz3 = function (value) {
            return _ableToAz3 = value;
        };

        var isAbleToAz4 = function () {
            return _ableToAz4;
        };

        var setAbleToAz4 = function (value) {
            return _ableToAz4 = value;
        };

        var pushNotificationUser = function (datacontext, notificationId) {
            return datacontext.notificationUser_push(notificationId).then(function (data) {
                if (data == null) return;
                return setNotificationCount(datacontext).then(function (data) {
                    return setNotification(datacontext).then(function (data) {
                        return _notifications;
                    });
                });
            });
        };

        function setNotificationCount(datacontext) {
            var iSistema = 0;
            return datacontext.authorization_get('<Tutto>').then(function (data) {
                if (data != null && typeof data != 'undefined') {
                    if (data.iTags == 131071) {
                        iSistema = 2;
                    }
                }
                return datacontext.notification_countAll('', true, 2, 2, iSistema).then(function (data) {
                    if (data == '500') data = 0;
                    return _notificationCount = data;
                });
            });   
        }

        function setNotification(datacontext) {
            var iSistema = 0;
            return datacontext.authorization_get('<Tutto>').then(function (data) {
                if (data != null && typeof data != 'undefined') {
                    if (data.iTags == 131071) {
                        iSistema = 2;
                    }
                }
                return datacontext.notification_getAll(0, 0, '', true, 2, 2, iSistema, '').then(function (data) {
                    return _notifications = data;
                });
            });   
        }

        function getNotificationCount() {
            return _notificationCount;
        }

        function getNotification() {            
            return _notifications;
        }


        var getLnkPDFBando = function () {
            return _lnkPDFBando;
        };

        var setLnkPDFBando = function (value) {
            return _lnkPDFBando = value;
        };

        var getLnkPDFManuale = function () {
            return _lnkPDFManuale;
        };

        var setLnkPDFManuale = function (value) {
            return _lnkPDFManuale = value;
        };

        var getLnkOfficialSite = function () {
            return _lnkOfficialSite;
        };

        var setLnkOfficialSite = function (value) {
            return _lnkOfficialSite = value;
        };

        var getUrlLogoHeader = function () {
            return _urlLogoHeader;
        };

        var setUrlLogoHeader = function (value) {
            return _urlLogoHeader = value;
        };

        var getInfoMsg = function () {
            return _showInfoMsg;
        };

        var setInfoMsg = function (value) {
            return _showInfoMsg = value;
        };

        var getProjectUId = function () {
            return _projectUId;
        };

        var setProjectUId = function (value) {
            return _projectUId = value;
        };

        var getTipoCandidatura = function () {
            return _tipoCandidatura;
        };

        var setTipoCandidatura = function (value) {
            return _tipoCandidatura = value;
        };

        var getLabelCF = function () {
            return _labelCF;
        };

        var setLabelCF = function (value) {
            return _labelCF = value;
        };

        return {
            setSection: setSection,
            getSection: getSection,
            isSectionActive: isSectionActive,
            getClassIfActive: getClassIfActive,
            isAbleToWork: isAbleToWork,
            setAbleToWork: setAbleToWork,
            //abilito il menu in base alle azioni attivate
            isAbleToAz1: isAbleToAz1,
            setAbleToAz1: setAbleToAz1,
            isAbleToAz2: isAbleToAz2,
            setAbleToAz2: setAbleToAz2,
            isAbleToAz3: isAbleToAz3,
            setAbleToAz3: setAbleToAz3,
            isAbleToAz4: isAbleToAz4,
            setAbleToAz4: setAbleToAz4,
            //Notifiche
            pushNotificationUser: pushNotificationUser,
            setNotificationCount: setNotificationCount,
            setNotification: setNotification,
            getNotificationCount: getNotificationCount,
            getNotification: getNotification,
            //Link PDF download
            getLnkPDFBando: getLnkPDFBando,
            setLnkPDFBando: setLnkPDFBando,
            getLnkPDFManuale: getLnkPDFManuale,
            setLnkPDFManuale: setLnkPDFManuale,
            //Link SIto Ufficiale
            getLnkOfficialSite: getLnkOfficialSite,
            setLnkOfficialSite: setLnkOfficialSite,
            //Url Logo Header
            getUrlLogoHeader: getUrlLogoHeader,
            setUrlLogoHeader: setUrlLogoHeader,
            //Show Info Message
            getInfoMsg: getInfoMsg,
            setInfoMsg: setInfoMsg,
            //Route ProjectID
            getProjectUId: getProjectUId,
            setProjectUId: setProjectUId,
            //Route TipoCandidatura
            getTipoCandidatura: getTipoCandidatura,
            setTipoCandidatura: setTipoCandidatura,
            //Label CF / PIVA invio email
            getLabelCF: getLabelCF,
            setLabelCF: setLabelCF
        };
    });
})();
